import React from "react";
import "./index.css";

export const Buttons = () => (
  <React.Fragment>
    <button className="default">Click me</button>
    <button className="default styled">Click me</button>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/examples/buttons/index.js